import spartaContentManagerUtility from '@sparta.global.utilities/sparta-content-manager-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaFootnoteUtility from '@sparta.global.utilities/sparta-footnote-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<header id=\"headerContent\"></header>\r\n\r\n<main id=\"mainContent\"></main>\r\n\r\n<footer id=\"footerContent\"></footer>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.wealth-shared.modules/single-page-orchestration-module",
  "version": "1.3.0",
  "id": "SinglePageOrchestrationModule",
  "containerID": "wealthSharedSinglePageOrchestrationModule",
  "moduleName": "wealth-shared-single-page-orchestration-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "single-page-orchestration-module",
  "data": {
    "init": "SinglePageOrchestrationModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "moduleManifest",
    "type": "Object",
    "description": "Page manifest that contains an array of module information to fetch from shield"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.5",
    "@sparta.global.utilities/sparta-content-manager-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-footnote-utility": "^1.0.0"
  },
  "stores": []
};

/* eslint-disable no-console */

/**
 * @export
 * @class SinglePageOrchestrationModule
 * @extends {Module}
 */
class SinglePageOrchestrationModule extends Module {
  /**
   * Creates an instance of SinglePageOrchestrationModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof SinglePageOrchestrationModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.moduleManifest = this.params.moduleManifest;
    this.pageKey = this.moduleManifest.pageKey;
    this.siteName = spaParams.siteName;
  }

  /**
   * @returns {void}
   */
  init() {
    this.orchestratePage();
  }

  /**
   * Reset placeholder elements
   *
   * @return {undefined}
   */
  emptyContent() {
    const childrenEls = [...this.settings.target.children];
    for (let i = 0; i < childrenEls.length; i++) {
      const child = childrenEls[i];
      child.innerHTML = '';
    }
  }

  /**
   * Shield Content
   * @return {Promise} shield content ( JSON )
   */
  getShieldContent() {
    return new Promise((resolve, reject) => {
      spartaContentManagerUtility.getContent({
        contentKey: `${this.siteName}.pages.${this.pageKey}`
      }).then(data => {
        if (typeof data === 'object') {
          resolve(data);
        } else {
          reject(data);
        }
      }).catch(err => {
        reject(err);
      });
    });
  }

  /**
   * @param {JSON} shieldContent content from shield
   * @returns {Promise} render done promise
   */
  renderModulesWithShieldData(shieldContent) {
    return new Promise((resolve, reject) => {
      const modulesToRender = [];
      this.moduleManifest.modules.forEach(moduleObj => {
        const {
          moduleName,
          location,
          moduleKey,
          backupDataSources,
          useBackupOverride,
          params
        } = moduleObj;
        modulesToRender.push({
          module: moduleName,
          target: location,
          context: {
            dataSources: useBackupOverride ? backupDataSources : shieldContent[moduleKey],
            ...(params && {
              params
            })
          }
        });
      });
      this.mountAll(modulesToRender).then(() => resolve()).catch(err => reject(err));
    });
  }

  /**
   * @returns {Promise} render done promise
   */
  renderModulesWithBackupData() {
    this.emptyContent();
    return new Promise((resolve, reject) => {
      const modulesToRender = [];
      this.moduleManifest.modules.forEach(moduleObj => {
        const {
          moduleName,
          location,
          backupDataSources,
          params
        } = moduleObj;
        modulesToRender.push({
          module: moduleName,
          target: location,
          context: {
            dataSources: backupDataSources,
            ...(params && {
              params
            })
          }
        });
      });
      this.mountAll(modulesToRender).then(() => resolve()).catch(err => reject(err));
    });
  }

  /**
   * Orchestrate Modules and Data
   *
   * @returns {undefined}
   */
  async orchestratePage() {
    try {
      // Fetch Shield Content
      const shieldContent = await this.getShieldContent();
      // Render Modules with Shield Content
      await this.renderModulesWithShieldData(shieldContent);
    } catch (error) {
      // Render Modules with Backup Content
      console.error(error);
      await this.renderModulesWithBackupData();
    }
    spartaFootnoteUtility.rebuildFootnotes();

    // Allow prerender snapshot to complete.
    if (typeof startPrerenderCapture === 'function') {
      startPrerenderCapture();
    }
  }
}
registerModuleClass({
  moduleClass: SinglePageOrchestrationModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { SinglePageOrchestrationModule as default, moduleConfig };
